import { styled } from '@mui/material';
import { Flex } from '../Flex';

export const StyledTooltipWrapper = styled(Flex)`
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(84, 103, 255, 0.2);
  box-shadow: 0 0 30px rgba(59, 89, 152, 0.15);
  border-radius: 5px;
  flex-direction: column;
`;
